import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '@/services/auth/auth.service';
import { MenuItem } from 'primeng/api';
import { AppSubject } from 'src/config/authorization.config';
import { SHARED_IMPORTS } from '@/utils/other/standalone-import';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule, SHARED_IMPORTS],
  template: `<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index">
      <li
        app-menuitem
        *ngIf="!item.separator"
        [item]="item"
        [index]="i"
        [root]="true"></li>
      <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
  </ul> `
})
export class AppMenu implements OnInit {
  private authService = inject(AuthService);

  model: MenuItem[] = [];

  ngOnInit() {
    this.generateMenu();
  }

  public generateMenu(): void {
    const $can = (subject: AppSubject) =>
      this.authService.$can('read', subject);

    const menu: MenuItem[] = [];

    menu.push({
      label: 'menu.dashboards.title',
      icon: 'pi pi-home',
      items: [
        {
          label: 'menu.dashboards.children.dashboard',
          icon: 'pi pi-fw pi-chart-bar',
          routerLink: ['/dashboard']
        }
      ]
    });

    const management = {
      label: 'menu.management.title',
      icon: 'pi pi-home',
      items: [] as MenuItem[]
    } as const;

    if ($can('Customer')) {
      management.items.push({
        label: 'menu.management.children.customers',
        icon: 'pi pi-fw pi-building',
        routerLink: ['/customers'],
        routerLinkActiveOptions: {
          paths: 'subset',
          queryParams: 'ignored',
          matrixParams: 'ignored',
          fragment: 'ignored'
        }
      });
    }

    if ($can('User')) {
      management.items.push({
        label: 'menu.management.children.userManagement.children.user',
        icon: 'pi pi-fw pi-user',
        routerLink: ['/users']
      });
    }

    menu.push(management);

    // const assignments = {
    //   label: 'menu.assignments.title',
    //   icon: 'pi pi-home',
    //   items: [] as MenuItem[]
    // } as const;

    // menu.push(assignments);

    // assignments.items.push({
    //   label: 'menu.assignments.children.calendar',
    //   icon: 'pi pi-fw pi-calendar',
    //   routerLink: ['/calendar']
    // });

    this.model = menu;
  }
}
